module.exports = __webpack_public_path__ + "img/buttom-bgc.a3ab8984.png";